<template>
  <div :class="$style.page">
    <Loading :loading="loading" :text="loadingText">
      <Title title="邮箱认证">
        <template v-slot:actions>
          <span :class="$style.goBack" @click="goBack">返回</span>
        </template>
      </Title>

      <Row>
        <Item title="邮箱">
          <el-input v-model.trim="email" />
        </Item>

        <Button type="primary" size="small" @click="searchEmail(1)">
          搜索
        </Button>
        <Button type="blue" @click="setVisible(true)"> 添加邮箱认证 </Button>
      </Row>

      <Divider />

      <Title title="搜索结果" :count="total" />

      <!-- 搜索结果 -->
      <el-table
        :data="showList"
        :fit="true"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column label="序号" width="30" align="center">
          <template slot-scope="scope">
            {{ limit * (page - 1) + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column prop="email" label="邮箱" width="120" align="center" />

        <el-table-column
          prop="createdTime"
          label="提交时间"
          width="120"
          align="center"
        />

        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            {{ mapStatus[scope.row.status] }}
          </template>
        </el-table-column>

        <el-table-column
          prop="expireTime"
          label="操作"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">-</span>
            <span v-else :class="$style.action_btn" @click="reSend(scope.row.email)">
              重新发送认证邮件
            </span>
            <span :class="$style.action_btn" @click="deleteEmail(scope.row.id)">
              删除
            </span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="page"
        :page-size="limit"
        :total="total"
        @current-change="loadMorePage"
      />
    </Loading>

    <EmailPopup
      mode="popup"
      :visible="visible"
      @close="setVisible(false)"
      @success="searchEmail"
    />
  </div>
</template>

<script>
import EmailPopup from "./certify/EmailPopup.vue";

import { getCertifyEmail, deleteCertifyEmail, createEmail } from "@server";

export default {
  name: "CertifyEmail",
  components: {
    EmailPopup,
  },
  data() {
    return {
      email: "",
      page: 1,
      limit: 10,
      showList: [],
      total: 0,

      loading: false,
      loadingText: "加载中...",
      visible: false,

      mapStatus: {
        0: "等待认证",
        1: "认证成功",
        2: "认证失败",
      },
    };
  },
  methods: {
    async searchEmail(page = 1) {
      this.loadingText = "加载中...";
      this.loading = true;
      this.page = page;

      const params = {
        limit: this.limit,
        page,
      };
      this.email && (params.email = this.email);
      const res = await getCertifyEmail(params);
      const { code, data } = res;

      if (code === 200) {
        this.showList = data.list;
        this.total = data.total;
      }

      this.loading = false;
    },

    async deleteEmail(id) {
      this.$confirm("确定要删除这条认证邮箱吗？", "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loadingText = "删除中...";
          this.loading = true;

          const res = await deleteCertifyEmail(id);
          if (res.code === 200) {
            this.$message({ message: "删除成功!", type: "success" });
            this.searchEmail();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
          this.loading = false;
        })
        .catch(() => {});
    },

    async reSend(email) {
      this.$confirm(`确定重新发送认证邮件到 ${email} ？`, "重发确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loadingText = "正在重发...";
          this.loading = true;

          const res = await createEmail({ email });
          if (res.code === 200) {
            this.$message({
              message: "认证邮箱已发送，请注意查收!",
              type: "success",
            });
          }
          this.loading = false;
        })
        .catch(() => {});
    },

    loadMorePage(page) {
      this.searchEmail(page);
    },

    setVisible(v) {
      this.visible = v;
    },

    goBack() {
      this.$router.push("/user/certification");
    },
  },
  created() {
    this.searchEmail(1);
  },
};
</script>

<style lang="scss" module scoped>
.page {
  min-height: 300px;
  padding: rem(50);
  padding-top: rem(10);
  background: $white;

  :global {
    .gl-title {
      margin-bottom: rem(20);
    }

    .gl-row {
      padding-bottom: rem(40);
    }

    .gl-item {
      margin-right: rem(30);
    }

    .el-input {
      width: rem(300);
    }

    .el-pagination {
      @include flex();
      margin-top: rem(50);
    }
  }

  .goBack {
    padding: 5px;
    font-size: rem(14);
    color: #333;
    cursor: pointer;
    &:hover {
      color: $theme-color;
    }
  }

  .action_btn {
    margin-right: 10px;
    cursor: pointer;
    &:hover {
      color: $theme-color;
    }
  }
}
</style>
